import Swiper, { Autoplay, Navigation, Pagination } from "swiper";
import createPhotoSwipe from '../../modules/create-photoswipe';

let lightBox;

/**
 * Create a Photoswipe gallery from an element that contains multiple <a> tags that should open images e.g. a slick carousel
 *
 * @param {HTMLElement} element
 * @returns function
 */
const setupPhotoswipe = (element) => {
    if (!element) {
        console.error('No target element found');
        return false;
    }

    // Build array of photos for Photoswipe to use as a gallery
    let photos = [];
    const elements = element.querySelectorAll('a');
    console.log('found elements for photoswipe:', elements);
    elements.forEach(item => {
        // If it's a cloned slide, don't use it as it will be a duplicate
        // Keep going up parent elements until .swiper-slide to is found or no parents exist
        let parent = item.parentElement;
        while (parent && !parent.classList.contains('swiper-slide')) {
            console.log('traversing up from', item, 'current parent:', parent);
            parent = parent.parentElement;
        }
        if (parent && parent.classList.contains('swiper-slide-duplicate')) {
            return;
        }
        console.log('adding photo for item:', item);
        let photo = {
            src : item.getAttribute('href'),
        };
        if (item.dataset.size) {
            let size = item.dataset.size.split('x');
            photo.w = parseInt(size[0]),
            photo.h = parseInt(size[1])
        }

        photos.push(photo);
        item.dataset.photoswipeIndex = photos.length - 1;
    });

    console.log('total photos for gallery:', photos.length);

    if (photos.length === 0) {
        console.error('No photos found for the gallery');
        return false;
    }

    console.log('binding click events for photoswipe elements');
    elements.forEach(item => {
        console.log('binding click event on ', item);
        item.addEventListener('click', (event) => {
            console.log('clicked', item, 'index:', parseInt(item.dataset.photoswipeIndex, 10))
            event.preventDefault();
            const index = parseInt(item.dataset.photoswipeIndex, 10);
            openPhotoSwipe(index);
        });
    });

    const openPhotoSwipe = (index) => {
        const options = {
            index: index,
            bgOpacity: 0.7,
            showHideAnimationType: 'fade',
        };

        lightBox = createPhotoSwipe(photos, options);

        lightBox.init();
    }
}

export const initContentGallerySlider = () => {
    const gallerySlices = document.querySelectorAll('.cms-content-gallery-slice');

    gallerySlices.forEach((el) => {
        const mainSwiper = initializeMainSlider(el);
        const labelSliderContainer = el.querySelector('.cms-content-gallery-slice__label-slider');

        if (mainSwiper && labelSliderContainer) {
            initializeLabelSlider(labelSliderContainer, mainSwiper);
        }

        console.log('setting up photoswipe on ', el)
        setupPhotoswipe(el);
    });
};

function initializeMainSlider(el) {
    const slider = el.querySelector('.cms-content-gallery-slice__main-swiper');
    const sliderDataset = slider.dataset;
    const slidesCount = slider.querySelectorAll('.swiper-slide').length;

    return new Swiper(slider, {
        modules: [Autoplay, Navigation, Pagination],
        speed: 100,
        loop: sliderDataset?.swiperLoop ?? false,
        loopedSlides: slidesCount,
        centeredSlides: true,
        slideToClickedSlide: true,
        navigation: {
            nextEl: el.querySelector('.cms-content-gallery-slice--next-no-labels'),
            prevEl: el.querySelector('.cms-content-gallery-slice--prev-no-labels'),
        },
        pagination: {
            el: el.querySelector('.cms-content-gallery-slice__pagination'),
            type: 'bullets',
            clickable: true,
        },
        breakpoints: {
            576: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: sliderDataset?.swiperSlidesPerView ?? 1,
            },
        },
    });
}

function initializeLabelSlider(container, mainSwiper) {
    const labelSwiperEl = container.querySelector('.cms-content-gallery-slice__swiper');
    if (!labelSwiperEl) return null;

    const labelItems = Array.from(labelSwiperEl.querySelectorAll('.cms-content-gallery-slice__pagination-labels--label'));

    const labelSwiper = new Swiper(labelSwiperEl, {
        modules: [Navigation],
        speed: 400,
        slidesPerView: 1,
        spaceBetween: 0,
        navigation: {
            nextEl: '.next-button-labels',
            prevEl: '.prev-button-labels',
        },
        breakpoints: {
            768: {
                slidesPerView: "auto",
                spaceBetween: 10,
            },
        },
        on: {
            slideChange: () => updateNavigationArrows(labelSwiper),
            click: () => handleLabelClick(labelSwiper)
        }
    });

    setActiveLabel(mainSwiper.realIndex, labelItems);

    function handleLabelClick(swiper) {
        const clickedIndex = swiper.clickedIndex;
        if (typeof clickedIndex !== 'undefined') {
            mainSwiper.slideToLoop(clickedIndex);
        }
    }

    function setActiveLabel(activeIndex, labels) {
        labels.forEach((label, index) => {
            label.classList.toggle('cms-content-gallery-slice__pagination-labels--label--active', index === activeIndex);
        });
    }

    function updateNavigationArrows(swiper) {
        const prevArrow = container.querySelector('.prev-button-labels');
        const nextArrow = container.querySelector('.next-button-labels');
        setArrowState(prevArrow, swiper.isBeginning);
        setArrowState(nextArrow, swiper.isEnd);
    }

    function setArrowState(arrow, isDisabled) {
        const circle = arrow.querySelector('svg circle');
        arrow.classList.toggle('cms-content-gallery-slice__disabled', isDisabled);
        circle.setAttribute('fill', isDisabled ? '#d8d8d8' : '#0B1E3A');
    }

    // function slideToNextItem() {
    //     const containerRect = labelSwiperEl.getBoundingClientRect();
    //     const lastLabelIndex = labelItems.length - 1;
    //     const lastLabelRect = labelItems[lastLabelIndex].getBoundingClientRect();
    //     // Check if the last label is partially visible
    //     if (lastLabelRect.right > containerRect.right && lastLabelRect.left < containerRect.right) {
    //         labelSwiper.slideToLoop(lastLabelIndex);
    //         updateNavigationArrows(labelSwiper)
    //     } else {
    //         let shiftAmount = 0;
    //         for (let i = 0; i <= lastLabelIndex; i++) {
    //             const labelRect = labelItems[i].getBoundingClientRect();
    //             if (labelRect.right > containerRect.right) {
    //                 shiftAmount = Math.ceil(labelRect.right - containerRect.right);
    //                 break;
    //             }
    //         }
    //         if (shiftAmount > 0) {
    //             labelSwiper.setTranslate(labelSwiper.translate - shiftAmount);
    //         }
    //     }
    // }

    const prevButton = container.querySelector('.cms-content-gallery-slice--prev');

    if (prevButton) {
        prevButton.addEventListener('click', () => {
            if (labelSwiper.params.slidesPerView === 1) {
                return;
            }
            if (!mainSwiper) return;

            // Determine if mainSwiper can go back. If loop is enabled there is always a next.
            const canGoBack = (mainSwiper.params && mainSwiper.params.loop) ? true : !mainSwiper.isBeginning;

            if (canGoBack) {
                mainSwiper.slidePrev();
            }
        });
    }

    const nextButton = container.querySelector('.cms-content-gallery-slice--next');

    if (nextButton) {
        nextButton.addEventListener('click', () => {
            if (labelSwiper.params.slidesPerView === 1) {
                return;
            }
            if (!mainSwiper) return;

            // Determine if mainSwiper can advance. If loop is enabled there is always a next.
            const canAdvance = (mainSwiper.params && mainSwiper.params.loop) ? true : !mainSwiper.isEnd;

            if (canAdvance) {
                mainSwiper.slideNext();
            }
        });
    }

    mainSwiper.on('slideChange', () => {
        const realIndex = mainSwiper.realIndex;
        setActiveLabel(realIndex, labelItems);
        labelSwiper.slideToLoop(realIndex);
    });

    labelSwiper.on('slideChange', () => {
        // if (labelSwiper.params.slidesPerView === 1) {
            const realIndex = labelSwiper.realIndex;
            mainSwiper.slideToLoop(realIndex);
        // }
    });

    return labelSwiper;
}